
<div class="box {{ info.typ }}">
  <div class="content">
    <div class="icon {{info.typ}}" >
      @if (info.icon != null) {
        <fa-icon [icon]="info.icon" size="md" [animation]="animation()"></fa-icon>
      }
    </div>
      <div class="text-wrapper">
      @if (info.titel) {
        <div class="titel">{{ info.titel }}</div>
      }
      @if (info.text) {
        <div class="text" [class.has-titel]="!!info.titel">{{ info.text }}</div>
      }
    </div>
    <div>
      @if (info.cancelable !== false) {
        <button jcIconButton (click)="userInfo.removeInfo(info)">x</button>
      }
    </div>
  </div>
  <div class="buttons">
    <div style="flex: 1;"></div>
    @for (button of info.buttons; track button) {
      <div style="width: 5px;"></div>
      @if (button.routerLink === null) {
        <button jcRaisedButton (click)="button.fnc();" color="primary">
          {{ button.text }}
        </button>
      }
      @if (button.routerLink !== null) {
        <a jcRaisedButton [routerLink]="button.routerLink" (click)="button.fnc();" color="primary">
          {{ button.text }}
        </a>
      }
    }
  </div>
</div>
